<template>
    <div class="article-terms-media">
        <p>Photographs and videos will be taken at Our Events for use by Swing Renegades in promotional materials.</p>
        <p>
            However, if you would prefer not to be included in these please let a member of Swing Renegades Team know
            your wishes and we will endeavour to omit you from these promotional materials - although we cannot
            guarantee that you will not be included.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleTermsMedia',
};
</script>
